/*
 * WOW Picks - the two product-recommendation blocks on product pages, run side
 * by side with Rebuy's widgets 280236 (Complete Your Ritual) and 262639 (You
 * may also like).
 *
 * Arm A (Rebuy): this file does nothing.
 * Arm B (ours):  this file draws both blocks where Rebuy's sit, then hides
 *                Rebuy's - one block at a time, and only once ours has products.
 *
 * The group comes from snippets/wow-cart-head.liquid (window.WowCartConfig).
 * Source of truth: storefront/wow-picks/ in the WOW repo - never edit this in
 * the Shopify theme editor, the next deploy overwrites it.
 */
(function (root) {
  'use strict';

  /* ---------- pure helpers (unit-tested in storefront/wow-picks/test) ---------- */

  function formatMoney(cents, format) {
    var value = (Number(cents) || 0) / 100;
    var fmt = format || '${{amount}}';
    function withCommas(n, decimals) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return withCommas(Math.round(value), 0);
      return withCommas(value, 2);
    });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Order of preference: what our own customers buy with this product, then
  // Shopify's suggestions, then the bestsellers. Never the product being viewed.
  function candidateHandles(current, recs, shopifyHandles, excludeHandles, max) {
    var skip = excludeHandles || [], out = [];
    function take(list) {
      (list || []).forEach(function (h) {
        if (!h || h === current || skip.indexOf(h) !== -1) return;
        if (out.indexOf(h) === -1 && out.length < max) out.push(h);
      });
    }
    take(recs && recs.pairs && recs.pairs[current]);
    take(shopifyHandles);
    take(recs && recs.bestsellers);
    return out;
  }

  function firstBuyable(p) {
    return ((p && p.variants) || []).filter(function (v) { return v.available && v.price > 0; })[0] || null;
  }

  function sameName(title) {
    return String(title || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  // Drops anything a shopper could not buy, and anything seen twice. The store
  // lists some sizes as separate products under one name (Fertile Mama 5 oz and
  // 2 oz), so names are compared too: a tea never recommends its own other size.
  function usableProducts(products, currentId, currentTitle) {
    var seen = {}, names = {}, out = [];
    if (currentTitle) names[sameName(currentTitle)] = true;
    (products || []).forEach(function (p) {
      var name = p && sameName(p.title);
      if (!p || seen[p.id] || p.id === currentId || (name && names[name])) return;
      if (!p.available || p.gift_card || !firstBuyable(p)) return;
      seen[p.id] = true;
      if (name) names[name] = true;
      out.push(p);
    });
    return out;
  }

  // "Complete Your Ritual" takes the first picks, "You may also like" the ones
  // after. The two on top are only repeated below when the row would otherwise
  // be shorter than one desktop page.
  function splitPicks(products, opts) {
    var ritual = products.slice(0, opts.ritual);
    var also = products.slice(opts.ritual, opts.ritual + opts.also);
    if (also.length < opts.minAlso) also = also.concat(ritual).slice(0, opts.also);
    return { ritual: ritual, also: also };
  }

  // Same steps as Rebuy's carousel: 4 across, 2 on tablets, 1 on phones.
  function perPageFor(width) {
    if (width >= 768) return 4;
    if (width >= 481) return 2;
    return 1;
  }

  function pageCount(count, perPage) {
    return count <= perPage ? 1 : Math.ceil(count / perPage);
  }

  // First card shown on a page. The last page never leaves a gap on the right.
  function pageStart(page, perPage, count) {
    return Math.max(0, Math.min(page * perPage, count - perPage));
  }

  function pageAfterSwipe(page, dx, pages, threshold) {
    if (dx <= -threshold) return Math.min(pages - 1, page + 1);
    if (dx >= threshold) return Math.max(0, page - 1);
    return page;
  }

  function starPercent(rating) {
    return Math.max(0, Math.min(100, (Number(rating) / 5) * 100)) || 0;
  }

  var helpers = {
    formatMoney: formatMoney, escapeHtml: escapeHtml, candidateHandles: candidateHandles,
    firstBuyable: firstBuyable, usableProducts: usableProducts, splitPicks: splitPicks,
    perPageFor: perPageFor, pageCount: pageCount, pageStart: pageStart,
    pageAfterSwipe: pageAfterSwipe, starPercent: starPercent
  };
  if (typeof module !== 'undefined' && module.exports) { module.exports = helpers; return; }

  /* ---------- browser only from here ---------- */

  var CFG = root.WowCartConfig;
  var PAGE = root.WowPicksConfig;
  if (!CFG || !PAGE || CFG.arm !== 'B') return;   // arm A: Rebuy, untouched
  var doc = root.document;

  var RITUAL = { id: '280236', title: 'Complete Your Ritual', src: 'picks-ritual', ready: 'wow-picks-ritual-ready' };
  var ALSO = { id: '262639', title: 'You may also like', src: 'picks-also-like', ready: 'wow-picks-also-ready' };
  var LIMITS = { ritual: 2, also: 8, minAlso: 4 };
  var SWIPE_PX = 40;

  function money(c) { return formatMoney(c, CFG.moneyFormat); }
  function base() { return CFG.routes.root.replace(/\/$/, ''); }

  /* ---------- data ---------- */

  function getRecs() {
    return root.fetch(PAGE.recsUrl)
      .then(function (r) { if (!r.ok) throw new Error('recs ' + r.status); return r.json(); })
      .catch(function () { return { pairs: {}, bestsellers: [] }; });
  }

  function shopifyRecs() {
    return root.fetch(base() + '/recommendations/products.json?product_id=' + PAGE.productId + '&limit=8&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { return (j.products || []).map(function (p) { return p.handle; }); })
      .catch(function () { return []; });
  }

  // Same section and the same 15-minute browser cache as the cart, so a product
  // the cart already looked up is not fetched twice.
  function getProduct(handle) {
    var key = 'wow_cart_p_' + handle;
    try {
      var hit = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (hit && hit.p && Date.now() - hit.t < 15 * 60 * 1000) return Promise.resolve(hit.p);
    } catch (e) { /* ignore */ }
    return root.fetch(base() + '/products/' + handle + '?section_id=wow-cart-product')
      .then(function (r) { if (!r.ok) throw new Error('product ' + r.status); return r.text(); })
      .then(function (html) {
        var m = html.match(/<script[^>]*data-wow-cart-product[^>]*>([\s\S]*?)<\/script>/);
        var p = JSON.parse(m[1]);
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), p: p })); } catch (e) { /* ignore */ }
        return p;
      })
      .catch(function () { return null; });
  }

  // XMLHttpRequest on purpose, not fetch: the shipping-protection app only
  // re-prices its checkout button after an XHR (see storefront/wow-cart/README).
  // The WOW cart watches for this request and opens itself.
  function addToCart(variantId, src) {
    return new Promise(function (resolve, reject) {
      var xhr = new root.XMLHttpRequest();
      xhr.open('POST', base() + '/cart/add.js');
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function () {
        var json = null;
        try { json = JSON.parse(xhr.responseText); } catch (e) { /* handled below */ }
        if (xhr.status >= 200 && xhr.status < 300 && json) { resolve(json); return; }
        reject(new Error((json && (json.description || json.message)) || 'Cart error'));
      };
      xhr.onerror = function () { reject(new Error('Network error')); };
      xhr.send(JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: { _wow_src: src } }] }));
    });
  }

  /* ---------- markup ---------- */

  function card(p, withButton) {
    var v = firstBuyable(p);
    var title = escapeHtml(p.title), url = escapeHtml(p.url);
    var image = v.image || p.image;
    var review = Number(p.rating_count) > 0
      ? '<div class="wow-picks__review" aria-label="product star rating">' +
          '<span class="wow-picks__stars">' +
            '<span class="wow-picks__sr">' + Number(p.rating) + ' stars out of 5 stars</span>' +
            '<span class="wow-picks__stars-bg"></span>' +
            '<span class="wow-picks__stars-fill" style="width:' + starPercent(p.rating) + '%"></span>' +
          '</span> ' +   // the space is part of Rebuy's spacing (0.6px), keep it
          '<span class="wow-picks__count">( ' + Number(p.rating_count) + ' Reviews )</span>' +
        '</div>'
      : '';
    return '' +
      '<div class="wow-picks__card" data-handle="' + escapeHtml(p.handle) + '">' +
        '<div class="wow-picks__media">' +
          '<a href="' + url + '" tabindex="-1" draggable="false">' +
            (image ? '<img loading="lazy" draggable="false" src="' + escapeHtml(image) + '" alt="' + title + '">' : '') +
          '</a>' +
        '</div>' +
        '<div class="wow-picks__info">' +
          '<h5 class="wow-picks__name"><a href="' + url + '" aria-label="View ' + title + '" draggable="false">' + title + '</a></h5>' +
          review +
          '<div class="wow-picks__price"><span class="wow-picks__money"><span class="wow-picks__sr">Price</span> ' +
            '<span>' + money(v.price) + '</span></span></div>' +
        '</div>' +
        (withButton
          ? '<div class="wow-picks__actions"><button type="button" class="wow-picks__button" data-wow-picks-add="' + v.id + '" ' +
            'aria-label="Add the product, ' + title + ' to Cart"><span>Add</span></button></div>'
          : '') +
      '</div>';
  }

  function shell(block, modifier, inner) {
    var el = doc.createElement('div');
    el.className = 'wow-picks wow-picks--' + modifier;
    el.setAttribute('data-wow-picks', block.src);
    el.innerHTML = '<h4 class="wow-picks__title">' + block.title + '</h4>' + inner;
    return el;
  }

  // Ours goes inside Rebuy's own theme block, right above Rebuy's widget, so it
  // sits in exactly the same place and keeps the block's spacing.
  function mount(block, el) {
    var anchor = doc.querySelector('[data-rebuy-id="' + block.id + '"]');
    if (!anchor || !anchor.parentNode) return false;
    anchor.parentNode.insertBefore(el, anchor);
    doc.documentElement.classList.add(block.ready);
    return true;
  }

  /* ---------- Complete Your Ritual ---------- */

  function renderRitual(products) {
    if (!products.length) return;
    var el = shell(RITUAL, 'ritual',
      '<div class="wow-picks__grid" role="region" aria-label="' + RITUAL.title + '">' +
        '<div class="wow-picks__list">' + products.map(function (p) { return card(p, true); }).join('') + '</div>' +
      '</div>');
    el.addEventListener('click', function (ev) {
      var button = ev.target.closest('[data-wow-picks-add]');
      if (!button || button.disabled) return;
      var label = button.querySelector('span');
      button.disabled = true;
      label.textContent = 'Adding...';
      addToCart(button.getAttribute('data-wow-picks-add'), RITUAL.src)
        .then(function () { label.textContent = 'Added!'; })
        .catch(function (e) {
          label.textContent = 'Add';
          if (root.console) root.console.error('[wow-picks] add failed', e);
        })
        .then(function () {
          setTimeout(function () { label.textContent = 'Add'; button.disabled = false; }, 1500);
        });
    });
    mount(RITUAL, el);
  }

  /* ---------- You may also like ---------- */

  function carousel(el, count) {
    var track = el.querySelector('.wow-picks__track');
    var list = el.querySelector('.wow-picks__list');
    var pager = el.querySelector('.wow-picks__pager');
    var cards = list.children;
    var perPage = 0, pages = 1, page = 0;

    function place(dragPx) {
      var start = pageStart(page, perPage, count);
      var pct = -(start * 100 / perPage);
      list.style.transform = dragPx ? 'translateX(calc(' + pct + '% + ' + dragPx + 'px))' : 'translateX(' + pct + '%)';
      Array.prototype.forEach.call(cards, function (c, i) {
        var shown = i >= start && i < start + perPage;
        // cards off to the side are skipped by the keyboard and screen readers
        if (shown) c.removeAttribute('aria-hidden'); else c.setAttribute('aria-hidden', 'true');
        var link = c.querySelector('.wow-picks__name a');
        if (link) link.tabIndex = shown ? 0 : -1;
      });
      Array.prototype.forEach.call(pager.querySelectorAll('button'), function (b, i) {
        b.classList.toggle('is-active', i === page);
        b.setAttribute('aria-selected', i === page ? 'true' : 'false');
        b.tabIndex = i === page ? 0 : -1;
      });
    }

    function go(to) {
      page = Math.max(0, Math.min(pages - 1, to));
      list.classList.remove('is-dragging');
      place(0);
    }

    function layout() {
      var next = perPageFor(root.innerWidth);
      if (next === perPage) return;
      var first = pageStart(page, perPage || next, count);
      perPage = next;
      pages = pageCount(count, perPage);
      var html = '';
      for (var i = 0; pages > 1 && i < pages; i++) {
        html += '<li role="presentation"><button type="button" role="tab" data-wow-picks-page="' + i + '" ' +
          'aria-label="Go to page ' + (i + 1) + '"></button></li>';
      }
      pager.innerHTML = html;
      pager.hidden = pages < 2;
      go(Math.floor(first / perPage));
    }

    pager.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-wow-picks-page]');
      if (b) go(Number(b.getAttribute('data-wow-picks-page')));
    });

    // Drag with a finger or the mouse, like Rebuy's. Up-and-down movement is
    // left to the page (touch-action: pan-y in the stylesheet).
    var drag = null, swallowClick = false;
    track.addEventListener('pointerdown', function (ev) {
      if (pages < 2 || (ev.pointerType === 'mouse' && ev.button !== 0)) return;
      drag = { id: ev.pointerId, x: ev.clientX, dx: 0, moved: false };
    });
    track.addEventListener('pointermove', function (ev) {
      if (!drag || ev.pointerId !== drag.id) return;
      drag.dx = ev.clientX - drag.x;
      if (!drag.moved && Math.abs(drag.dx) < 6) return;
      if (!drag.moved) {
        drag.moved = true;
        list.classList.add('is-dragging');
        try { track.setPointerCapture(drag.id); } catch (e) { /* ignore */ }
      }
      place(drag.dx);
    });
    function release(ev) {
      if (!drag || ev.pointerId !== drag.id) return;
      var d = drag;
      drag = null;
      if (!d.moved) return;
      swallowClick = true;
      setTimeout(function () { swallowClick = false; }, 50);
      go(pageAfterSwipe(page, d.dx, pages, SWIPE_PX));
    }
    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);
    // a drag must not count as a click on the product under the pointer
    track.addEventListener('click', function (ev) {
      if (!swallowClick) return;
      ev.preventDefault();
      ev.stopPropagation();
    }, true);
    track.addEventListener('dragstart', function (ev) { ev.preventDefault(); });

    root.addEventListener('resize', layout);
    layout();
  }

  function renderAlso(products) {
    if (!products.length) return;
    var el = shell(ALSO, 'also',
      '<div class="wow-picks__grid" role="region" aria-roledescription="carousel" aria-label="' + ALSO.title + '">' +
        '<div class="wow-picks__track"><div class="wow-picks__list">' +
          products.map(function (p) { return card(p, false); }).join('') +
        '</div></div>' +
        '<ul class="wow-picks__pager" role="tablist" aria-label="Select a slide to show"></ul>' +
      '</div>');
    carousel(el, products.length);
    mount(ALSO, el);
  }

  /* ---------- start ---------- */

  function fail(e) {
    // Anything going wrong here must leave the shopper with Rebuy's blocks.
    doc.documentElement.classList.remove(RITUAL.ready, ALSO.ready);
    Array.prototype.forEach.call(doc.querySelectorAll('[data-wow-picks]'), function (n) { n.remove(); });
    if (root.console) root.console.error('[wow-picks] start failed', e);
  }

  function start() {
    if (!doc.querySelector('[data-rebuy-id="' + RITUAL.id + '"], [data-rebuy-id="' + ALSO.id + '"]')) return;
    Promise.all([getRecs(), shopifyRecs()]).then(function (r) {
      var handles = candidateHandles(PAGE.handle, r[0], r[1], CFG.excludeHandles, LIMITS.ritual + LIMITS.also + 4);
      return Promise.all(handles.map(getProduct));
    }).then(function (products) {
      var picks = splitPicks(usableProducts(products, PAGE.productId, PAGE.title), LIMITS);
      renderRitual(picks.ritual);
      renderAlso(picks.also);
      root.WowPicks = { ready: true, ritual: picks.ritual.length, also: picks.also.length };
    }).catch(fail);
  }

  try {
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
    else start();
  } catch (e) { fail(e); }
})(typeof window !== 'undefined' ? window : this);
